import React from 'react';
import { Row } from '@thd-olt-component-react/core-ui';
import { Typography } from '@one-thd/sui-atomic-components';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { EXP_ROUTES } from '../../utils/constants';
import SplashPageButton from './SplashPageButton';

const LandingBanner = () => {

  return (
    <Row className="splash-page-banner">
      <ErrorBoundary name="splash-page-banner">
        <div className="splash-page-banner__container" aria-label="Banner Image Skilled Tradespeople">
          <div className="splash-page-banner__content">
            <Typography variant="h2" weight="display">Hire Skilled Tradespeople for Your Business</Typography>
            <section className="splash-page-banner__text">
              The Path to Pro Network connects you to the skilled tradespeople your business needs.
            </section>
            <SplashPageButton
              buttonText="View Tradespeople"
              destination={EXP_ROUTES.CANDIDATE_SEARCH}
              analyticsLabel="find candidates"
              variant="primary"
            />
          </div>
        </div>
      </ErrorBoundary>
    </Row>
  );
};

export default LandingBanner;
